import Page from '@/components/layout/Page';
import BackButton from '@/components/common/BackButton';
import HorizontalLogo from '@/components/common/HorizontalLogo';

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import AddCoachForm from './components/addCoachPage/AddCoachForm';

const AddCoachPage = () => {
  return (
    <Page>
      <BackButton to="/application/add" />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Personal Information</CardTitle>
        </CardHeader>
        <CardContent>
          <AddCoachForm />
        </CardContent>
      </Card>
    </Page>
  );
};

export default AddCoachPage;
